import { History, ScrollText } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const auditNavigation: NavItem[] = [
  {
    to: '/audit/activities',
    labelKey: 'nav.activities',
    group: 'nav.groups.reports',
    icon: ScrollText,
    permission: 'audit.view',
  },
  {
    to: '/audit/access-logs',
    labelKey: 'nav.accessLogs',
    group: 'nav.groups.reports',
    icon: History,
    permission: 'audit.view',
  },
]
